import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useCurrentUser } from '../auth';

interface RequirePermissionProps {
  permission: string;
  children: React.ReactNode;
  fallbackPath?: string;
}

const RequirePermission: React.FC<RequirePermissionProps> = ({
  permission,
  children,
  fallbackPath = '/dashboard',
}) => {
  const { permissions, isCurrentUserLoading } = useCurrentUser();

  if (isCurrentUserLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  if (!permissions.includes(permission)) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
};

export default RequirePermission;
